import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { sso } from "@env/cogntio-domain";
import { catchError, tap } from "rxjs/operators";
import { HttpUtilService } from "./http-util.service";
import { NotificationsService } from "./notifications.service";

@Injectable({
  providedIn: "root",
})
export class CognitoDomainService {
  private _cognitoDomainState = new BehaviorSubject({
    isLoading: true,
    cognitoDomain: null,
  });

  private _cognitoSsoUrl = new BehaviorSubject(sso);
  private hasAttemptedCognitoDomain: boolean = false;
  
  constructor(
    private notifications: NotificationsService,
    private http: HttpUtilService,
    private environmentService: EnvironmentService
  ) {}
  getCognitoSsoUrl$() {
    return this._cognitoSsoUrl.asObservable();
  }

  updateCognitoSsoUrl() {
    this.http
      .request(
        "POST",
        this.environmentService.environment.apiRoot + "/cognito-domain"
      )
      .pipe(catchError((error) => of({ error })))
      .pipe(
        tap((response) => {
          if (!response || response.error) {
            this.notifications.popNotification(
              "",
              "Error Updating Cogntio Domain. You may experience issues with logging in with SSO. Please disable all identity providers at this time as a precaution."
            );
          }
        })
      )
      .subscribe();
  }

  getCogntioDomainNetworkRequest() {
    this.http
      .request(
        "GET",
        this.environmentService.environment.apiRoot + "/cognito-domain"
      )
      .pipe(catchError((error) => of({ error })))
      .pipe(
        tap((response: any) => {
          this._cognitoDomainState.next({
            isLoading: false,
            cognitoDomain:
              !response || response?.error || typeof response !== "string"
                ? null
                : response,
          });
        })
      )
      .subscribe();
  }



  getCogntioDomain$() {
    if (!this.hasAttemptedCognitoDomain) {
      this.hasAttemptedCognitoDomain = true;
      this.getCogntioDomainNetworkRequest();
    }
    return this._cognitoDomainState.asObservable();
  }


}
